import { render, staticRenderFns } from "./header-common.vue?vue&type=template&id=f3908fa8"
import script from "./header-common.vue?vue&type=script&lang=js"
export * from "./header-common.vue?vue&type=script&lang=js"
import style0 from "./header-common.vue?vue&type=style&index=0&id=f3908fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports